__webpack_public_path__ = window['.cfg'].staticsPath || '/';

import React from 'react';
import ReactDOM from 'react-dom';

import { TranslationProvider } from './services/TranslationService';
import { ProfileProvider } from './services/ProfileService';
import { ModalProvider } from './services/ModalService';

import OnboardingRoutes from './routes';

import 'src/styles/global-styles.scss';
import 'src/styles/darwinex-from-components-library.scss';

ReactDOM.render(
    <React.StrictMode>
        <div className="page-wrapper s-darwinex">
            <TranslationProvider>
                <ProfileProvider>
                    <ModalProvider>
                        <OnboardingRoutes/>
                    </ModalProvider>
                </ProfileProvider>
            </TranslationProvider>
        </div>
    </React.StrictMode>,
    window.document.getElementById('root'),
);
